<template>
  <FormStepInputs
    :step="{
      stepName: name,
      formInputs: content,
    }"
  >
    <template #emailAddressAlreadyUsedMessage>
      <div v-if="emailIsTaken" class="flex md:w-176 items-start gap-4 mt-4">
        <InformationBox
          :title="emailAddressAlreadyUsedMessage.title.value"
          :description="emailAddressAlreadyUsedMessage.content.value"
          :type="emailAddressAlreadyUsedMessage.messageType.value"
          :isCircle="true"
          :useButtonSlot="false"
        ></InformationBox>
      </div>
    </template>
    <template #internetBankingMessage>
      <div v-if="showInternetBankingMessage" class="flex md:w-176 items-start gap-4 mt-4">
        <InformationBox
          :title="internetBankingMessage.title.value"
          :description="internetBankingMessage.content.value"
          :type="internetBankingMessage.messageType.value"
          :isCircle="true"
          :useButtonSlot="false"
        ></InformationBox>
      </div>
    </template>
    <template #disclaimer> </template>
  </FormStepInputs>
  <div>
    <ContactInformationForm
      :emailAddressInput="emailAddress"
      :phoneNumberInput="phoneNumber"
      :additionalPhoneNumberInput="additionalPhoneNumber"
      :profileLink="profileLink"
      :content="content"
      @emailIsTaken="(e: boolean) => updateEmailIsValid(e)"
    ></ContactInformationForm>
  </div>
  <div class="!mt-10 mb-10 md:!mt-12 md:!mb-12">
    <Divider></Divider>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { ISitecoreFormGenericInput } from '@/interfaces';
import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import { getFormInput } from '@/utils/form-input-helper';
import { PageAnalyticsBuilder } from '@/utils/page-analytics-builder';
import InformationBox from '@/components/InformationBox/InformationBox.vue';
import ContactInformationForm from './ContactInformationForm.vue';
import Divider from '@/components/Divider/Divider.vue';
import { useAccountStore } from '@/store';

const props = defineProps<{
  content: ISitecoreFormGenericInput[];
  id: string;
  name: string;
}>();

const accountStore = useAccountStore();

const emailIsTaken = ref<boolean>(false);
const showInternetBankingMessage = ref<boolean>(false);

const internetBankingMessage = ref(getFormInput(props.content, 'internetBankingMessage'));
const emailAddress = ref(getFormInput(props.content, 'emailAddress'));
const phoneNumber = ref(getFormInput(props.content, 'phoneNumber'));
const additionalPhoneNumber = ref(getFormInput(props.content, 'additionalPhoneNumber'));
const profileLink = ref(getFormInput(props.content, 'profileLink'));
const emailAddressAlreadyUsedMessage = ref(getFormInput(props.content, 'emailAddressAlreadyUsedMessage'));

const dictionary = useI18n().getLocaleMessage('en') as Record<string, string>;

onMounted(() => {
  showInternetBankingMessage.value = (accountStore.identityDetails?.portfolio?.bankingProducts?.length ?? 0) > 0;
  pushAnalytics();
});

const updateEmailIsValid = (e: boolean) => {
  emailIsTaken.value = e;
};

const pushAnalytics = () => {
  const pageAnalytics = new PageAnalyticsBuilder();
  pageAnalytics.populateProducts(dictionary);
  pageAnalytics.pushAnalytics();
};
</script>
